import React, { useEffect, useState, useContext } from "react";
import BaseModal, { MODALSIZES } from "../BaseModal";
import ModalContext from "../../../context/ModalContext";
import ModalEnum from "../BaseModal/ModalEnum";
import useLanguage from '../../../utilities/useLanguage';
import { getSettingAsDelimitedList, getSettingAsHtml, SettingsEnum } from '../../../utilities/settings';
import { getTranslation } from '../translations'
import { isLPLDisclaimerRequired, isExitLink } from "./disclaimerUtils";
import styled from "styled-components";
import getTargetLink from "../../../utilities/getTargetLink";

export enum DisclaimerType {
    NONE = 'NONE',
    EXIT = 'EXIT',
    LPL = 'LPL',
};

const ModalContent = styled.div`
    .disclaimer {
        margin-bottom: 2.333rem;
        p {
            color: var(--mud);
            font-size: 1.333rem;
            line-height: 1.467rem;
            font-weight: 500;
        }
    }
`;

export default () => {
    const { openModal, closeModals } = useContext(ModalContext);
    const [continueData, setContinueData] = useState({continueUrl: "", disclaimerType: DisclaimerType.NONE});
    const { continueUrl, disclaimerType } = continueData;
    const { lang } = useLanguage();

    // Settings from context
    const lplDisclosurePaths = getSettingAsDelimitedList(SettingsEnum.LPL_DISCLOSURE_PATHS);
    const exitDisclaimerExcludeLinks = getSettingAsDelimitedList(SettingsEnum.EXIT_DISCLAIMER_EXCLUDE_LINKS);
    const lplDisclosureHtml = getSettingAsHtml(SettingsEnum.LPL_DISCLOSURE_HTML);
    const lplDisclosureHtmlSpanish = getSettingAsHtml(SettingsEnum.LPL_DISCLOSURE_HTML_SPANISH);
    const exitDisclaimerHtml = getSettingAsHtml(SettingsEnum.EXIT_DISCLAIMER_HTML);
    const exitDisclaimerHtmlSpanish = getSettingAsHtml(SettingsEnum.EXIT_DISCLAIMER_HTML_SPANISH);


    const closeDisclaimer = () => {
        setContinueData({ continueUrl: "", disclaimerType: DisclaimerType.NONE });
        closeModals();
    };

    const openDisclaimer = (continueUrl, disclaimerType) => {
        setContinueData({ continueUrl, disclaimerType });
        openModal(ModalEnum.Disclaimer);
    };

    const showDisclaimer = () => {
        if (disclaimerType === DisclaimerType.EXIT) {
            return lang === 'es' ? exitDisclaimerHtmlSpanish : exitDisclaimerHtml
        } else {
            return lang === 'es' ? lplDisclosureHtmlSpanish : lplDisclosureHtml
        }
    }

    useEffect(() => {
        function handleCheckForFinancesLink(event) {
            const target = getTargetLink(event);
            if (!target || !target.href || target.classList.contains("skip-disclaimer-modal")) {
                return;
            }
            if (isExitLink(target.href, exitDisclaimerExcludeLinks)) {
                event.preventDefault();
                openDisclaimer(target.href, DisclaimerType.EXIT);
                return;
            }
            if (isLPLDisclaimerRequired(target.href, lplDisclosurePaths)) {
                event.preventDefault();
                openDisclaimer(target.href, DisclaimerType.LPL);
            }
        }
        document.addEventListener("click", handleCheckForFinancesLink);
        return () => {
            document.removeEventListener("click", handleCheckForFinancesLink);
        };
    }, []);
    return (
        <BaseModal backdropClassName={"modal-backdrop-glass"} modalId={ModalEnum.Disclaimer} modalSize={MODALSIZES.DISCLAIMER}>
            <ModalContent className="justify-content-center disclaimer-modal">
                <div className="disclaimer">
                    {showDisclaimer()}
                </div>
                <div className="text-center">
                    {disclaimerType === DisclaimerType.EXIT && <button className="btn btn-outline-dark mr-2" onClick={closeDisclaimer}>{getTranslation(lang).goBack}</button>}
                    <a className="btn btn-primary skip-disclaimer-modal" onClick={closeDisclaimer} target={disclaimerType === DisclaimerType.EXIT ? "_blank" : "_self"} href={continueUrl}>{getTranslation(lang).continue}</a>
                </div>
            </ModalContent>
        </BaseModal>
    );
};
